/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import '../../../atoms/text/css/text';
import '../../../atoms/svg/css/svg';
import './button.scss';
import './modifier/primary.scss';
import './modifier/secondary.scss';
import './modifier/tactful.scss';
import './modifier/accordion.scss';
import './modifier/icon-only.scss';
import './modifier/icon-animation.scss';
import './modifier/icon-size.scss';
import './modifier/horizontal-nav.scss';
import './modifier/color.scss';
import './modifier/filter.scss';
import './modifier/mobile-full-width.scss';
import './modifier/full-width.scss';
import './modifier/collapse.scss';
import './modifier/favorite.scss';
import './modifier/small.scss';
import './modifier/link.scss';
import './modifier/upload.scss';
import './modifier/related.scss';
import './modifier/pulse.scss';
import './modifier/word-break.scss';
